import type { Xinglet } from '@xing-com/crate-xinglet';

import { Container } from './container';

export default class DreamMachineStartpageLoggedOut implements Xinglet {
  public createContexts(
    publish: (contextId: string, contextValue: unknown) => void
  ): void {
    publish('find-jobs-ads', { ads: [], isCompleted: false });
  }

  public getComponent() {
    return (): JSX.Element => <Container />;
  }
}
